import { type StepName } from '@eduzz-registry-360/validators';
import { useMutation } from '@tanstack/react-query';

import { trpcVanillaClient } from '@/lib/trpc';
import { isRetryable, RETRY_DELAYS_MS } from '@/lib/trpcRetry';

export const SAVE_STEP_MUTATION_KEY = ['registry', 'save'];

export const useSaveStep = () => {
  return useMutation({
    mutationKey: SAVE_STEP_MUTATION_KEY,
    mutationFn: async ({ step, data }: { step: StepName; data: Record<string, unknown> }) => {
      return trpcVanillaClient.registry.save.mutate({ step, data });
    },
    retry: (failureCount, error) => {
      if (failureCount >= RETRY_DELAYS_MS.length) {
        return false;
      }

      return isRetryable(error);
    },
    retryDelay: attempt => RETRY_DELAYS_MS[attempt] ?? RETRY_DELAYS_MS[RETRY_DELAYS_MS.length - 1]
  });
};
